import 'magnific-popup';

const initWpBlockGalleryMagnificPopup = () => {
  $.extend(true, $.magnificPopup.defaults, {
    tClose: 'Fermer (Esc)', // Alt text on close button
    tLoading: 'Chargement...', // Text that is displayed during loading. Can contain %curr% and %total% keys
    gallery: {
      tPrev: 'Précédent', // Alt text on left arrow
      tNext: 'Suivant', // Alt text on right arrow
      tCounter: '%curr% sur %total%', // Markup for "1 of 7" counter
    },
    image: {
      tError: '<a href="%url%">L\'image</a> n\'a pas pu être chargée.', // Error message when image could not be loaded
      titleSrc: item => {
        const $figcaption = item.el.siblings('figcaption');

        if ($figcaption.length) {
          return $figcaption.text();
        }

        return '';
      },
    },
    ajax: {
      tError: '<a href="%url%">Le contenu</a> n\'a pu être chargé.', // Error message when ajax request failed
    },
  });

  $('.wp-block-image').each((i, e) => {
    const $imageBlock = $(e);

    if ($imageBlock.closest('.row').length === 0 && $imageBlock.find('a').length) {
      $imageBlock.magnificPopup({
        delegate: 'a',
        type: 'image',
      });
    }
  });

  $('.wp-block-gallery').each((i, e) => {
    const $galleryBlock = $(e);

    if ($galleryBlock.find('a').length) {
      $galleryBlock.magnificPopup({
        delegate: 'a',
        type: 'image',
        gallery: {
          enabled: true,
        },
      });
    }
  });

  $('.row').each((i, e) => {
    const $row = $(e);

    if ($row.find('.wp-block-image a').length) {
      $row.magnificPopup({
        delegate: 'a',
        type: 'image',
        gallery: {
          enabled: true,
        },
      });
    }
  });
};

export default initWpBlockGalleryMagnificPopup;
